document.addEventListener("DOMContentLoaded", function() {

  // 

  setTimeout(() =>{
    let review_button = document.querySelectorAll('.reviews_all_container .kl_reviews__reviews_list button.kl_reviews__button');
  
    if (review_button) {
        review_button.forEach(function (e) {
            let btnText = e.textContent;
            e.setAttribute('aria-description', btnText)
        })
    }    
  }, 1000)

  // 

  let products_hover = document.querySelectorAll('.product-card .product-card__figure');

  if (products_hover.length > 0) {
      products_hover.forEach(function (e) {        
          let imgs = e.querySelectorAll('img');
          imgs.forEach(function (img) {
              img.setAttribute('alt', '')
          });
          
          e.addEventListener('mouseover', function () {
              let secondImgs = e.querySelectorAll('img.product-card__image.product-card__image--secondary');
              secondImgs.forEach(function (img) {
                  img.style.display = 'none';
              });
  
              let firstImgs = e.querySelectorAll('a>img');
              firstImgs.forEach(function (img) {
                  img.style.opacity = 1;
              });            
              
          });
      });
  }

})